import React, { Component } from 'react'

class Unauthorized extends Component {
  render () {
    return (
      <div className='fourohfour-wrapper unauthorized-wrapper'>
        <div className='fourohfour-text-wrapper'>
          <i className='fa fa-low-vision' />
          <h3 className='text-center'>Unauthorized</h3>
        </div>
      </div>
    )
  }
}
export default Unauthorized



// WEBPACK FOOTER //
// ./src/components/basic/displays/Unauthorized.js